import { toCamelCaseProperties } from '@/utils/fn';
import UmbracoBase from './UmbracoBase';

export default class CustomHTML extends UmbracoBase {
	constructor(args) {
		super(args); // Extending UmbracoBase
		args = toCamelCaseProperties(args) || {};

		this.componentName = 'custom-html';
		this.html = args.rawHTML || '';
	}
}
